import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Enter data for job quote", -1)
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title py-4",
  id: "invite_a_friend_modal_label"
}, " Recipient Information: ", -1)
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "w-100 me-2" }
const _hoisted_10 = { class: "w-100 ms-2" }
const _hoisted_11 = { class: "d-flex mt-4 align-items-center" }
const _hoisted_12 = { class: "w-100 me-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 ms-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title mt-10 pb-4",
  id: "invite_a_friend_modal_label"
}, " Quote Information: ", -1)
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "w-100 me-2 d-flex flex-column" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "w-100 ms-2 d-flex flex-column" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "mt-4 d-flex" }
const _hoisted_23 = { class: "w-100 me-2 d-flex flex-column" }
const _hoisted_24 = { class: "w-100 ms-2 d-flex flex-column" }
const _hoisted_25 = { class: "mt-10 d-flex gap-9" }
const _hoisted_26 = { class: "w-25 d-flex min-w-300px flex-column" }
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table table-row-dashed table-striped table-row-gray-300 align-middle" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px w-175px px-9" }, "Required skill"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity")
  ])
], -1)
const _hoisted_30 = { class: "px-9" }
const _hoisted_31 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_32 = ["onChange"]
const _hoisted_33 = { class: "w-75" }
const _hoisted_34 = { class: "table table-row-dashed table-striped table-row-gray-300 align-middle" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Skill"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty"),
    /*#__PURE__*/_createElementVNode("th", null, "Price"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" })
  ])
], -1)
const _hoisted_36 = { class: "px-9" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "mt-10" }
const _hoisted_42 = { class: "d-flex gap-4 pb-4 mt-10 justify-content-end" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SkillsDropdown = _resolveComponent("SkillsDropdown")!
  const _component_currencies_dropdown = _resolveComponent("currencies-dropdown")!
  const _component_DeleteButtonIcon = _resolveComponent("DeleteButtonIcon")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.editing ? "Edit" : "Create") + " Job quote", 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives((_openBlock(), _createBlock(_component_Form, {
        ref: "formComponent",
        "validation-schema": _ctx.validationSchema,
        class: "d-flex flex-column",
        onSubmit: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.quoteData.company,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quoteData.company) = $event)),
                class: "w-100",
                onChange: _ctx.handleClientSelect,
                "allow-create": "",
                filterable: "",
                size: "large",
                clearable: "",
                placeholder: "Select Company"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: company.value,
                      value: company.value,
                      label: company.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Field, {
                type: "text",
                modelValue: _ctx.quoteData.address,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quoteData.address) = $event)),
                class: "form-control form-control-solid",
                placeholder: "Enter address",
                name: "address"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Field, {
                type: "text",
                modelValue: _ctx.quoteData.vat,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quoteData.vat) = $event)),
                class: "form-control form-control-solid",
                placeholder: "Enter VAT/Company ID",
                name: "company_indentifier"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_13
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Field, {
                type: "text",
                modelValue: _ctx.quoteData.title,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quoteData.title) = $event)),
                class: "form-control form-control-solid",
                placeholder: "Enter Title",
                name: "quote_title"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_ErrorMessage, { name: "quote_title" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_SkillsDropdown, { onChange: _ctx.onSkillChange }, null, 8, ["onChange"]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_ErrorMessage, { name: "skills" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_select, {
                class: "w-100",
                modelValue: _ctx.quoteData.unit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quoteData.unit) = $event)),
                size: "normal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "hour",
                    label: "Hour"
                  }),
                  _createVNode(_component_el_option, {
                    value: "day",
                    label: "Day"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_currencies_dropdown, {
                modelValue: _ctx.quoteData.currency,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.quoteData.currency) = $event)),
                class: "w-100"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleAddSkills && _ctx.handleAddSkills(...args))),
                class: "btn btn-success w-100 justify-content-center align-items-center d-flex h-35px mb-5"
              }, " Add "),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("table", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSkills, (subSkill) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: subSkill.id
                      }, [
                        _createElementVNode("td", _hoisted_30, _toDisplayString(subSkill.name), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("input", {
                              class: "form-control w-75px form-control-sm",
                              type: "number",
                              onChange: 
                            ev =>
                              _ctx.handleChange(
                                ev.target.value,
                                subSkill.id,
                                subSkill.name
                              )
                          
                            }, null, 40, _hoisted_32)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("table", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quoteSkill, (quote, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: quote.id
                    }, [
                      _createElementVNode("td", _hoisted_36, _toDisplayString(quote.name), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control w-75px form-control-sm",
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((quote.qty) = $event)
                        }, null, 8, _hoisted_37), [
                          [_vModelText, quote.qty]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control w-75px form-control-sm",
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((quote.price) = $event)
                        }, null, 8, _hoisted_38), [
                          [_vModelText, quote.price]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_39, [
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (_ctx.handleDeleteSkill(index)), ["prevent"]),
                          class: "btn btn-icon btn-bg-danger btn-active-color-light btn-sm me-1"
                        }, [
                          _createVNode(_component_DeleteButtonIcon, {
                            dynamicClass: 'svg-icon-white',
                            svgSize: 'svg-icon-3'
                          })
                        ], 8, _hoisted_40)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.quoteData.notes) = $event)),
              class: "form-control form-control-solid",
              placeholder: "Enter notes",
              rows: "3"
            }, null, 512), [
              [_vModelText, _ctx.quoteData.notes]
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.saving,
              class: "btn btn-primary"
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.editing ? "Edit" : "Save") + " quote ", 1)
            ], 8, _hoisted_43)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ]))
}